import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Stack from "@mui/material/Stack";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import "./config.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SpecificModal from "./SpecificModal.jsx"; // Import the SpecificModal component
import { useNavigate } from "react-router-dom";
import logUserAction from "utils/logging";
import { callUnsetApi } from "utils/api";
const extraMapping = {
  0: "Off",
  1: "On",
};
const Configuration = () => {
  const [rows, setRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSpecificModalOpen, setIsSpecificModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [hbFreq, setHbFreq] = useState("");
  const [rfFreq, setRfFreq] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    if (!userData) {
      navigate("/");
    } else {
      sessionStorage.setItem("lastVisitedPage", "/dashboard");
    }
  }, [navigate]);

  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("userDetails");
    if (storedUserData) {
      const parsedData = JSON.parse(storedUserData);
      setUserDetails(parsedData);
    }
  }, []);
  console.log(userDetails);
  const siteId = sessionStorage.getItem("selectedSiteId");
  console.log(siteId);

  useEffect(() => {
    return () => {
      callUnsetApi(siteId);
    };
  }, [siteId]);
  const breadcrumbs = [
    <Link key="1"></Link>,
    <Typography key="2" sx={{ color: "text.primary" }}>
      Configuration
    </Typography>,
  ];

  const openModal = (row) => {
    setSelectedRow(row);
    setIsModalOpen(true);
    setIsSpecificModalOpen(false);
  };
  const openSpecificModal = (row) => {
    setSelectedRow(row);
    setIsSpecificModalOpen(true);
    setIsModalOpen(false);
  };
  const openAddModal = () => {
    setIsAddModalOpen(true);
  };
  const closeAddModal = () => {
    setIsAddModalOpen(false);
  };

  const closeSpecificModal = () => {
    setIsSpecificModalOpen(false); // Close the modal
    setSelectedRow(null); // Optionally, reset the selected row
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setIsSpecificModalOpen(false);
  };

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal")) {
      closeModal();
    } else if (e.target.classList.contains("specific-modal")) {
      closeSpecificModal();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!hbFreq || !rfFreq) {
      toast.error("Please fill out all fields!");
      return;
    }

    const payload = {
      hb_freq: parseInt(hbFreq),
      rf_freq: parseInt(rfFreq),
    };
    console.log(payload);

    try {
      const response = await fetch(
        "https://api.bharatnet.sunshineiotronics.com/api/v2/update_generic_config",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit data");
      }

      const message = await response.text(); // Read response as text, not JSON
      toast.success(message, { autoClose: 5000 }); // Show the success message from server response
      logUserAction(
        `Submitted form with payload: hb_freq=${payload.hb_freq}, rf_freq=${payload.rf_freq}`
      );
      setTimeout(() => {
        closeModal(); // Close the modal
        window.location.reload(); // Reload the page
      }, 2000); // Delay the modal close and page reload by 5 seconds
    } catch (error) {
      console.error("Error submitting data:", error);
      toast.error("Failed to update settings. Please try again.");
    }
  };
  const payload = userDetails ? { circles: userDetails.circles } : {};

  useEffect(() => {
    if (!userDetails) return; // Don't fetch data if userDetails is null

    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://api.bharatnet.sunshineiotronics.com/api/v2/profile/all",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        setRows(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [userDetails]); // This effect runs whenever userDetails changes

  return (
    <Box m="1.5rem 2.5rem">
      <div className="container-fluid page-body-wrapper">
        <br />
        <br />
        <div className="main-panel">
          <div className="content-wrapper">
            <Stack spacing={2}>
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="medium" />}
                aria-label="breadcrumb"
              >
                {breadcrumbs}
              </Breadcrumbs>
            </Stack>
          </div>
        </div>
      </div>
      <br />
      <div className="table-container">
        <div className="table-header">
          <button class="button" onClick={openModal}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              viewBox="0 0 20 20"
              height="20"
              fill="none"
              class="svg-icon"
            >
              <g stroke-width="1.5" stroke-linecap="round" stroke="#997d3d">
                <circle r="2.5" cy="10" cx="10"></circle>
                <path
                  fill-rule="evenodd"
                  d="m8.39079 2.80235c.53842-1.51424 2.67991-1.51424 3.21831-.00001.3392.95358 1.4284 1.40477 2.3425.97027 1.4514-.68995 2.9657.82427 2.2758 2.27575-.4345.91407.0166 2.00334.9702 2.34248 1.5143.53842 1.5143 2.67996 0 3.21836-.9536.3391-1.4047 1.4284-.9702 2.3425.6899 1.4514-.8244 2.9656-2.2758 2.2757-.9141-.4345-2.0033.0167-2.3425.9703-.5384 1.5142-2.67989 1.5142-3.21831 0-.33914-.9536-1.4284-1.4048-2.34247-.9703-1.45148.6899-2.96571-.8243-2.27575-2.2757.43449-.9141-.01669-2.0034-.97028-2.3425-1.51422-.5384-1.51422-2.67994.00001-3.21836.95358-.33914 1.40476-1.42841.97027-2.34248-.68996-1.45148.82427-2.9657 2.27575-2.27575.91407.4345 2.00333-.01669 2.34247-.97026z"
                  clip-rule="evenodd"
                ></path>
              </g>
            </svg>
            <span class="lable">Settings</span>
          </button>

          {/* Modal */}
          {isModalOpen && selectedRow && (
            <div className="modal open" onClick={handleOutsideClick}>
              <div className="modal-content">
                <span className="close" onClick={closeModal}>
                  &times;
                </span>
                <h2>Generic Settings</h2>
                <form className="form-control" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="hb_freq">Heartbit (In Sec)</label>
                    <input
                      type="number"
                      id="hb_freq"
                      className="form-control"
                      placeholder="Enter value"
                      min="5"
                      max="60"
                      autoComplete="off"
                      value={hbFreq}
                      onChange={(e) => setHbFreq(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="rf_freq">Periodic Data (In Sec)</label>
                    <input
                      type="number"
                      id="rf_freq"
                      className="form-control"
                      placeholder="Enter value"
                      min="1"
                      max="10800"
                      autoComplete="off"
                      value={rfFreq}
                      onChange={(e) => setRfFreq(e.target.value)}
                    />
                  </div>
                  <button type="submit" className="btn btn-primary">
                    Save Changes
                  </button>
                </form>
              </div>
            </div>
          )}
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        {/* Table content */}
        <br />
        <br />
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead className="table-dark">
              <tr>
                <th>Action</th>
                <th>Site ID</th>
                <th>MAC ID</th>
                <th>Serial No.</th>
                <th>Heartbit (In Sec)</th>
                <th>Periodic Data (In Sec)</th>
                <th>Circle</th>
                <th>District</th>
                <th>Taluka</th>
                <th>Village</th>
                <th>Pin Code</th>
                <th>Latitude</th>
                <th>Longitude</th>
                <th>Level 01 Contact</th>
                <th>Level 02 Contact</th>
                <th>Email 1</th>
                <th>Email 2</th>
                <th>Server State NOC</th>
                <th>Server Centre NOC</th>
                <th>Debug NOC</th>
                <th>Auto Download</th>
                <th>Auto Upgrade</th>
                <th>Remote Reboot</th>
                <th>Factory Restore</th>
                <th>Hardware Version</th>
                <th>Software Version</th>
              </tr>
            </thead>
            <tbody>
              {rows.length > 0 ? (
                rows.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <button
                        class="button"
                        onClick={() => openSpecificModal(row)}
                        style={{
                          width: "40px",
                          backgroundColor: "rgb(250,223,186)",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          width="20"
                          viewBox="0 0 20 20"
                          height="20"
                          class="svg-icon"
                        >
                          <g
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke="#997d3d"
                          >
                            <circle r="2.5" cy="10" cx="10"></circle>
                            <path
                              fill-rule="evenodd"
                              d="m8.39079 2.80235c.53842-1.51424 2.67991-1.51424 3.21831-.00001.3392.95358 1.4284 1.40477 2.3425.97027 1.4514-.68995 2.9657.82427 2.2758 2.27575-.4345.91407.0166 2.00334.9702 2.34248 1.5143.53842 1.5143 2.67996 0 3.21836-.9536.3391-1.4047 1.4284-.9702 2.3425.6899 1.4514-.8244 2.9656-2.2758 2.2757-.9141-.4345-2.0033.0167-2.3425.9703-.5384 1.5142-2.67989 1.5142-3.21831 0-.33914-.9536-1.4284-1.4048-2.34247-.9703-1.45148.6899-2.96571-.8243-2.27575-2.2757.43449-.9141-.01669-2.0034-.97028-2.3425-1.51422-.5384-1.51422-2.67994.00001-3.21836.95358-.33914 1.40476-1.42841.97027-2.34248-.68996-1.45148.82427-2.9657 2.27575-2.27575.91407.4345 2.00333-.01669 2.34247-.97026z"
                              clip-rule="evenodd"
                            ></path>
                          </g>
                        </svg>
                      </button>
                    </td>
                    <td>{row.site_id}</td>
                    <td>{row.mac_id}</td>
                    <td>{row.serial_no}</td>
                    <td>{row.hb_freq}</td>
                    <td>{row.rf_freq}</td>
                    <td>{row.state}</td>
                    <td>{row.dist}</td>
                    <td>{row.tal}</td>
                    <td>{row.village}</td>
                    <td>{row.pin_code}</td>
                    <td>{row.lat}</td>
                    <td>{row.long}</td>
                    <td>{row.level_01_contact}</td>
                    <td>{row.level_02_contact}</td>
                    <td>{row.email_1}</td>
                    <td>{row.email_2}</td>
                    <td>{row.server_state_noc}</td>
                    <td>{row.server_centre_noc}</td>
                    <td>{row.debug_noc}</td>
                    <td>{extraMapping[row.auto_download]}</td>
                    <td>{extraMapping[row.auto_upgrade]}</td>
                    <td>{extraMapping[row.remote_reboot]}</td>
                    <td>{extraMapping[row.factory_restore]}</td>
                    <td>{row.hw_version}</td>
                    <td>{row.sw_version}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="22" style={{ textAlign: "center" }}>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {/* SpecificModal - Only open if modal is true */}
          {isSpecificModalOpen && selectedRow && (
            <SpecificModal
              selectedRow={selectedRow}
              closeModal={closeSpecificModal}
              handleOutsideClick={handleOutsideClick}
            />
          )}
        </div>
      </div>
    </Box>
  );
};

export default Configuration;
